import { render, staticRenderFns } from "./search-word-list.vue?vue&type=template&id=f71ba998&scoped=true&"
import script from "./search-word-list.vue?vue&type=script&lang=js&"
export * from "./search-word-list.vue?vue&type=script&lang=js&"
import style0 from "./search-word-list.vue?vue&type=style&index=0&id=f71ba998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71ba998",
  null
  
)

export default component.exports